import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=b52346c6&scoped=true&"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=b52346c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52346c6",
  null
  
)

export default component.exports